/*global googletag, window*/

import * as MediaModule from "shared_critical/media/index.js";

MOVE.Medias = (function () {
  "use strict";

    var loadProgrammaticAds = function(slots) {
      MediaModule.LoadProgrammaticAds(slots);
    };

    var viewport = function () {
        var e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return { width: e[a + 'Width'], height: e[a + 'Height'] };
    };

    var getWindowWidth = function () {
        var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
        var android = /Android/i.test(navigator.userAgent);
        if (iOS || android) {
            return $(window).width();
        }
        else {
            return viewport().width;
        }
    };

    var windowWidth = getWindowWidth(),
        resizeTimer;

    //helper method to get the type of teh view
    var getType = function (type) {
        return (type === "map" || type === "list") ? type : "list";
    };

    // Get view type either "map" or "list"
    var getViewType = function () {
      let type;
      if ($('.component_ab-view-switch').length) {  // this is for the for new SRP AB test
        type = $.cookie('ab_srp_viewtype');
        return (type === 'ab-list-view') ? 'list' : (type === 'ab-mixed-view') ? 'map' : 'map-only';
      }
      else {
        type = $.cookie('srp.viewType');
        return getType(type);
      }
    };

    var hidePeelBackAds = function () {
        $('#div-gpt-ad-oop').hide().removeClass('visible-lg-inline-block'); // this is for new peelback template
        $('div[data-studioassetid]').hide(); // this is for lagecy peelback ads created by gpt studio, they will go away eventually
    };

    var showPeelBackAds = function () {
        $('#div-gpt-ad-oop').show().addClass('visible-lg-inline-block'); // this is for new peelback template
        $('div[data-studioassetid]').show(); // this is for lagecy peelback ads created by gpt studio, they will go away eventually
    };

    var loadOOPAds = function () {
        return getWindowWidth() >= 1280;
    };

    var concatSRPListViewAds = function (adsToBeRefreshed) {
      if (ab_test_lb1_v3_check()) {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsLB1ListViewOnly.targets);
      } else {
        $('.ab_test_lb1list_v3').css("display","none");
      }

      adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsListViewOnly.targets);
      adsToBeRefreshed = adsToBeRefreshed.concat(MediaModule.SrpCurrentStickMrect());
      if (loadOOPAds()) {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsOutOfPage.targets);
        showPeelBackAds();
      }
      return adsToBeRefreshed;
    };

    var addAdsToBeRefreshed = function(adsToBeRefreshed, ad) {
      if (ad.isLoaded) {
          adsToBeRefreshed = adsToBeRefreshed.concat(ad.targets);
      }
      return adsToBeRefreshed;
    };

    var setViewport = function() {
      var view_port = MOVE.Helper.detectViewPort();
      var viewport_mapping = {'large':    'LRG',
                              'medium':   'MED',
                              'small':    'SM',
                              'x-small':  'XS',
                              'xx-small': 'XXS'
                             };
      googletag.pubads().setTargeting('VIEWPORT',[viewport_mapping[view_port]]);
    };

    var refreshAds = function() {
      var adsToBeRefreshed = window.gptAds.gptadslots.targets; // for auto load ads
      adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsPreload.targets); // for preload ads
      var pageType = MOVE.DOMHelper.detectPageType();
      if (pageType === 'srp') { // check to make sure it is srp
        hidePeelBackAds();
        showSrpAdForView(getViewType());
        if (getViewType() === "list") { // for loaded list view ads
          MediaModule.SrpResetStickyMrect();
          adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsTXTINListView.loaded);
          if (window.gptAds.gptadslotsTILE1PreloadListView.isLoaded)
            adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsTILE1PreloadListView.targets);
          adsToBeRefreshed = concatSRPListViewAds(adsToBeRefreshed);
        }
        else {
          adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsTXTINMapView.loaded);
          if (window.gptAds.gptadslotsTILE1PreloadMapView.isLoaded)
            adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsTILE1PreloadMapView.targets);
        }

        if (ab_test_lb1_v3_check()) {
          adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsLB1QuickViewOnly.targets);
        } else {
          $('.ab_test_qvlb1_v3').css("display","none");
        }

        if (window.gptAds.gptadslotsQuickViewOnly.isLoaded) {
          adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsQuickViewOnly.targets);
        }
        if (window.gptAds.gptadslotsFullPhotoGallery.isLoaded) {
          adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsFullPhotoGallery.targets);
        }
      }
      else if (pageType === 'ldp' || pageType === 'mortgage') {
          hidePeelBackAds();
          if (loadOOPAds()) {
              adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsOutOfPage.targets);
              showPeelBackAds();
          }

          if (ab_test_lb1_v3_check()) {
            adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsLB1FullLdpOnly.targets);
          } else {
            $('.ab_test_fulllb1_v3').css("display","none");
          }

          adsToBeRefreshed = addAdsToBeRefreshed(adsToBeRefreshed, window.gptAds.gptadslotsFullPhotoGallery);
      }
      if (window.hp_cln) {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsCLN.targets);
      }

      setViewport();

      // for gptadslotsPhotoGallery, gptadslotsFullPhotoGallery, gptadslotsEMP, now the ads inside no need responsive support, so skip. If in future need, add code here
      loadProgrammaticAds(adsToBeRefreshed);
    };

    var resizer = function() {
        if (resizeTimer) {
            clearTimeout(resizeTimer);
        }
        resizeTimer = setTimeout(refreshAds, 250);
    };

    var onResize = function() {
      var newWindowWidth = getWindowWidth();
      if (newWindowWidth !== windowWidth) {
        windowWidth = newWindowWidth;
        $('#div-gpt-ad-TXTIN2').find('.txtinadslistview').removeClass('dap-size');
        $('#div-gpt-ad-TILELIST2').removeClass('dap-mrect');
        $('.ads-section').find('.ads').removeClass('fluid');
        resizer();
      }
    };

    var getDynamicAdsToBeLoaded = function(adsUnitNames, adSlotArray) {
      var adsToBeRefreshed = [];
      $(adsUnitNames.split(",")).each(function(j, adUnitToDisplay) {
        if (adUnitToDisplay === "") {
          return;
        }
        adSlotArray.targets.forEach(function (slot) {
          if (slot && slot.getTargeting('pos').includes(adUnitToDisplay)) {
            adsToBeRefreshed.push(slot);
          }
        });
      });
      return adsToBeRefreshed;
    };

    var getTXTINAdsToBeLoaded = function(view, includePreloadTile1) {
      var adsTXTINToBeRefreshed = [];
      var currentView = view || getViewType();
      let tileAdListToDisplay = MediaModule.GetTileAdListToDisplay(currentView);
      if (currentView === "list") {
        adsTXTINToBeRefreshed = getDynamicAdsToBeLoaded(tileAdListToDisplay, window.gptAds.gptadslotsTXTINListView);
        window.gptAds.gptadslotsTXTINListView.loaded = adsTXTINToBeRefreshed;
        if (includePreloadTile1) {
          adsTXTINToBeRefreshed = adsTXTINToBeRefreshed.concat(getDynamicAdsToBeLoaded(tileAdListToDisplay, window.gptAds.gptadslotsTILE1PreloadListView));
        }
      }
      else if (currentView === 'map' && !MOVE.Helper.isPhone()) {
        adsTXTINToBeRefreshed = getDynamicAdsToBeLoaded(tileAdListToDisplay, window.gptAds.gptadslotsTXTINMapView);
        window.gptAds.gptadslotsTXTINMapView.loaded = adsTXTINToBeRefreshed;
        if (includePreloadTile1) {
          adsTXTINToBeRefreshed = adsTXTINToBeRefreshed.concat(getDynamicAdsToBeLoaded(tileAdListToDisplay, window.gptAds.gptadslotsTILE1PreloadMapView));
        }
      }
      return adsTXTINToBeRefreshed;
    };

    var firstTimeLoadSrp = true;
    var showSrpAdForView = function (view) {
      if (firstTimeLoadSrp) {
        firstTimeLoadSrp = false;
      }
      else {
        $('.fluid_tile_ad').removeClass('fluid_tile_ad');
      }
      if (view === "list") {
        $('.txtinadslistview').removeClass('hide');
        $('.mcc_tile_card').addClass('hide');
      }
      else {
        $('.txtinadsmapview').removeClass('hide');
      }
    };

    var set_srp_zip1 = function () {
      if ($('.ad-data-post-code').length) {
        var postcode = $('.ad-data-post-code')[0].dataset['postcode'];
        if (postcode) {
          googletag.pubads().setTargeting('SRPZIP1',[postcode]);
        }
      }
    };

    var srpLoadAds = function (view, includePreloadTile1) {
      view = view || getViewType();
      view = view.toLowerCase();
      hidePeelBackAds();
      googletag.cmd.push(function() {
        refreshAdsTargettingForViewChange(view);
        var adsToBeRefreshed = getTXTINAdsToBeLoaded(view, includePreloadTile1);
        if (view === "list") {
          adsToBeRefreshed = concatSRPListViewAds(adsToBeRefreshed);
        }
        else {
          if (ab_test_lb1_v3_check()) {
            adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsLB1MapViewOnly.targets);
          } else {
            $('.ab_test_lb1map_v3').css("display","none");
          }
          adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsMapViewOnly.targets);
        }
        set_srp_zip1();
        loadProgrammaticAds(adsToBeRefreshed);
        showSrpAdForView(view);
        MediaModule.TileAdLazyLoad(getDynamicAdsToBeLoaded, loadProgrammaticAds, view);
      });
    };

    var srpPageLoad = function () {
      srpLoadAds('list');
    };

    var renderNormalAds = function() {
      setViewport();

      var pagetype = MOVE.DOMHelper.detectPageType();
      if (pagetype === 'srp') {
        if (getViewType() === "list") {
          srpPageLoad();
        }
      }
      else {
        var adsToBeRefreshed = window.gptAds.gptadslots.targets;

        if (pagetype === 'ldp') {
          MediaModule.LdpAdLazyLoading(loadProgrammaticAds);
          if (ab_test_lb1_v3_check()) {
            adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsLB1FullLdpOnly.targets);
          } else {
            $('.ab_test_fulllb1_v3').css("display","none");
          }
        }

        if (loadOOPAds()) {
          adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsOutOfPage.targets);
        }
        if (window.hp_cln) {
          adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsCLN.targets);
        }
        loadProgrammaticAds(adsToBeRefreshed);
      }
    };

    var initAds = function () {

      renderNormalAds();
      if(!MOVE.DataStore.getData('vuSweepsGnavEnabled')){	
        $(".vu-link").addClass('hide');	
      }

      $(window).on('resize orientationchange', onResize);

      if (MOVE.Helper.isPageType('srp')) {
        $(window).on('scroll', _.debounce(function() {
          MediaModule.SrpOnScroll(getViewType, loadProgrammaticAds);
        }, 200));
      }
    };

    var manualLoadAds = function (options, adsClass, forceReload, setQuickViewTargeting) {
      if (window.ads_library.initialized) {
        googletag.cmd.push(function() {
          if (!options.isLoaded || options.needReload || forceReload) {
            if (adsClass && (!options.isLoaded)) {
              $(adsClass).each(function() {
                googletag.display(this.getAttribute('id'));
              });
            }
            options.isLoaded = true;
            options.needReload = false;

            if (setQuickViewTargeting) {
              options.targets.forEach(function (slot) {
                if (slot) {
                  $.each(window.gptAds.quickview_targeting, function(key, val){
                    slot.setTargeting(key, [val.replace(/'/g,'')]);
                  });
                }
              });
            }

            loadProgrammaticAds(options.targets);
          }
        });
      }
      else {
        setTimeout(function() {
            manualLoadAds(options, adsClass, forceReload, setQuickViewTargeting);
          }, 1000);
      }
    };

    var getVideoMrectAdsToBeLoaded = function() {
      var adsVedioMrectToBeRefreshed = getDynamicAdsToBeLoaded(window.videoMrectAdUnitsToDisplay, window.gptAds.gptadslotsVideoMrect);
      window.gptAds.gptadslotsVideoMrect.loaded = adsVedioMrectToBeRefreshed;
      manualLoadAds(window.gptAds.gptadslotsVideoMrect, '.ads');
    };

    var srpListingsChange = function () {
      srpLoadAds();
    };

    var srpSearchChange = function () {
      srpLoadAds();
    };

    var srpMapLoad = function () {
      if (!MOVE.Helper.isPhone()) {
        srpListingsChange();
      }
    };

    var refreshAdsEnhancementKeys = function () {
      try {
        window.amznads.getAdsCallback('3103',
          function () {
              window.amznads.setTargetingForGPTAsync('amznslots');
          }
        );
        googletag.pubads().clearTargeting('amznslots');
      }
      catch(e) { /* ignore */ }
    };

    var refreshAdsTargettingForViewChange = function (view) {
        googletag.pubads().setTargeting('view',[view]);
        window.kxdl.view = view;
        refreshAdsEnhancementKeys();
    };

    var srpViewChange = function (view) {
      view = view || getViewType();
      view = view.toLowerCase();
      if (view === "list" || !MOVE.Helper.isPhone())
      {
        srpLoadAds(view, true);
      }
    };

    var srpInitMapView = function(isMapViewToggle) {
      if (getViewType() === 'map') {
        srpLoadAds('map', isMapViewToggle && window.SRPPreloadTile1Ad);
      }
    };

    var kruxPixel = function (pixelId, option) {
        try {
            window.Krux('admEvent', pixelId, option);
        }
        catch (e) { /* for ad block */ }
    };

    const quickview_keys = ['cityldp', 'citystldp', 'zipldp', 'countyldp', 'agent_advertiser_id', 'broker_advertiser_id', 'office_advertiser_id',
      'bkr', 'pldp', 'address', 'mlid', 'mprid', 'mls', 'bid', 'offbid', 'advertiser', 'customkv', 'ptldp', 'pfldp', 'garageldp',
      'listingprice', 'agehom', 'lotldp', 'sqft', 'sqldp', 'bedldp', 'bathldp', 'add', 'lstat', 'openldp', 'rdpr', 't'];

    var resetQuickViewAds = function () {
      window.gptAds.gptadslotsQuickViewPreloadOnly.needReload = true;
      window.gptAds.gptadslotsQuickViewOnly.needReload = true;
      window.gptAds.gptadslotsQuickViewMap.needReload = true;
      window.gptAds.gptadslotsQuickViewMapExp.needReload = true;
      window.gptAds.gptadslotsPhotoGallery.needReload = true;
      window.gptAds.gptadslotsFullPhotoGallery.needReload = true;
      window.gptAds.gptadslotsEMP.needReload = true;
      window.gptAds.gptadslotsEMPSRP.needReload = true;
      window.gptAds.gptadslotsPaymentOptionOnly.needReload = true;
      window.gptAds.gptadslotsQuickViewPropertyDetails.needReload = true;
      $('.ad-quick-view-preload').addClass('TXTLDPLoading');
    };

    var setQuickViewKeyValue = function (targeting) {
      window.gptAds.quickview_targeting = targeting;
      $.each(targeting, function(key, val){
        window.kxdl[key] = val.replace(/'/g,'');
      });
      googletag.cmd.push(function() {
        googletag.pubads().setTargeting('refresh',['N']);
      });
    };

    var clearQuickViewKeyValue = function () {
      window.gptAds.quickview_targeting = {};
      $.each(quickview_keys, function(i, val){
        delete window.kxdl[val];
      });
    };

    var reloadSrpAdOnQuickViewClose = function () {
      //for now, we only reload srp ad when it is Collaps Card, which is variation2 of ab_id_SRPBCQV
      //if we productionize and select Collaps Card, we need remove the if condition.
      if (document.getElementById('ab_id_SRPBCQV:variation2')) {
        googletag.cmd.push(function() {
          googletag.pubads().setTargeting('refresh',['Y']);
          srpLoadAds();
        });
      }
    };

    var gptTracking = function (value, force_load) {
      googletag.cmd.push(function() {
        if (value) {
          window.gptAds.gptadslotsTracking.targets.forEach(function (element) {
            element.setTargeting('status', [value]);
            element.setTargeting('customkv', [value]);
          });
        }
        manualLoadAds(window.gptAds.gptadslotsTracking, 'pixel', force_load);
      });
    };

    var articleTrackingUsedKey = articleTrackingUsedKey || [];
    var articleTrackingAttributionData = articleTrackingAttributionData || [];
    var doArticleTracking = function (attributionData) {
      $.each(articleTrackingUsedKey, function(index, key) {
        if (window.article_tracking_slot) {
          window.article_tracking_slot.setTargeting(key, []);
        }
      });

      // track via DFP
      if (attributionData) {
        $.each(attributionData, function(key, val) {
          if ($.inArray(key, articleTrackingUsedKey) < 0) {
            articleTrackingUsedKey.push(key);
          }
          if (window.article_tracking_slot) {
            window.article_tracking_slot.setTargeting(key, val);
            window.article_tracking_slot.setTargeting('random', Math.random());
          }
        });
      }
      manualLoadAds(window.gptAds.gptadslotsArticleTracking, '.article_tracking', true);
    };

    var articleTrackingTimer;
    var articleTrackingManager = function() {
      if (articleTrackingAttributionData.length > 0) {
        var attributionData = articleTrackingAttributionData.shift();
        doArticleTracking(attributionData);
      }
      if (articleTrackingAttributionData.length > 0) {
        setTimeout(articleTrackingManager, 1000);
      }
    };

    var articleTracking = function (attributionData) {
      articleTrackingAttributionData.push(attributionData);
      if (articleTrackingTimer) {
        clearTimeout(articleTrackingTimer);
      }
      articleTrackingTimer = setTimeout(articleTrackingManager, 500);
    };

  var init = function(preloadAdEnabled) {
    MediaModule.MediaInit()
      .then( () => {
        if (!preloadAdEnabled) {
          window.preloadAds();
        }
        initAds();
      }, () => {
        //do nothing if ad library not initialized
      });
  };

  var ab_test_lb1_v3_check = function() {
    return false;
    
    const media_lb1_ad_var = MOVE_DATA.media_lb1_ad_var;
    let ksg = "";
    if (window.Krux && window.Krux.segments)
      ksg = window.Krux.segments;

    //ksg = "ucjhvnbv9";
    ksg = decodeURIComponent(ksg).split(',');
    if (media_lb1_ad_var === "V2" && (ksg.includes('ucjhvnbv9')|| ksg.includes('ucjhw2hv5')||
        ksg.includes('ucjhx6c61')|| ksg.includes('ucjhzeonp')|| ksg.includes('ucjh1f0li')))
    {
      $('.have-lb1-above-gnav').removeClass('have-lb1-above-gnav');
      return false;
    }

    return true;
  };

  var showViewCreditScoreAd = function() {
    if (window.gptAds && window.gptAds.gptadslotsLeadOverlayOnly && window.gptAds.gptadslotsLeadOverlayOnly.targets.length) {
      MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsLeadOverlayOnly, '.lead_thank_you', true);
      $('#div-gpt-ad-BTNLEAD1').removeClass('hide');
      $('#view_credit_scores_button').addClass('hide');
    }
    else {
      $('#div-gpt-ad-BTNLEAD1').addClass('hide');
      $('#view_credit_scores_button').removeClass('hide');
    }
  };

  var loadMCCOverlayAd = function(movingModalSelectorId) {
    if (getViewType() === "list") {
      MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsMCCModal, movingModalSelectorId + ' .ads');
    }
    else {
      MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsMCCModalMap, movingModalSelectorId + ' .ads');
    }
  };

  var getEmptyTile1Ad = function() {
    if (getViewType() === "list") {
      $('#div-gpt-ad-TILELIST1').parents('.txtinadslistview').addClass('hide');
      if (!MOVE.Helper.isPhone()) {
        $('.mcc_tile_card').removeClass('hide');
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsMCCTile);
      }
    }
    else {
      $('#div-gpt-ad-TILEMAP1').parents('.txtinadsmapview').addClass('hide');
    }
  };

  var currentVET = "";
  var loadAFCALCOverlayAd = function(affordabilityModal, vet) {
    if (vet !== currentVET) {
      currentVET = vet;
      window.googletag.pubads().setTargeting('VET',[vet]);
      if (getViewType() === "list") {
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsAFCALCModalList, affordabilityModal + ' .ads', true);
      }
      else {
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsAFCALCModalMap, affordabilityModal + ' .ads', true);
      }
    }
  };

  var currentVET2 = "";
  var currentVIEW = "";
  var loadPFILTERCOverlayAd = function(filter) {
    let vet = $('#affordability-vetbenefits').is(":checked") ? "Y" : "N";
    let view = getViewType();
    if (vet !== currentVET2 || view !== currentVIEW) {
      currentVET2 = vet;
      currentVIEW = view;
      window.googletag.pubads().setTargeting('VET',[vet]);
      if (view === "list") {
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsPFILTERModalList, filter + ' .ads', true);
      }
      else {
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsPFILTERModalMap, filter + ' .ads', true);
      }
    }
  };

  return {
      init: init,
      manualLoadAds: manualLoadAds,
      getVideoMrectAdsToBeLoaded: getVideoMrectAdsToBeLoaded,
      srpViewChange: srpViewChange,
      srpListingsChange: srpListingsChange,
      srpMapLoad: srpMapLoad,
      srpInitMapView: srpInitMapView,
      srpPagination: srpLoadAds,
      srpSearchChange: srpSearchChange,
      articleTracking: articleTracking,
      gptTracking: gptTracking,
      showViewCreditScoreAd: showViewCreditScoreAd,
      ab_test_lb1_v3_check: ab_test_lb1_v3_check,
      resetQuickViewAds: resetQuickViewAds,
      setQuickViewKeyValue: setQuickViewKeyValue,
      clearQuickViewKeyValue: clearQuickViewKeyValue,
      reloadSrpAdOnQuickViewClose: reloadSrpAdOnQuickViewClose,
      loadMCCOverlayAd: loadMCCOverlayAd,
      getEmptyTile1Ad: getEmptyTile1Ad,
      loadAFCALCOverlayAd: loadAFCALCOverlayAd,
      loadPFILTERCOverlayAd: loadPFILTERCOverlayAd,
      kruxPixel: kruxPixel
    };
})();

window.addEventListener("message", MediaModule.HandleAdsMessage, false);



// WEBPACK FOOTER //
// ./shared_critical/media.js